import { useCallback, useEffect, useState } from 'react';

import { fetchCohortes, fetchDomaines, fetchFilieres } from '../services/academiaApprenantService';
import { groupFilieresForPublicVitrine } from '../utils/publicFilieres';

/**
 * Catalogue public = filières + cohortes ouvertes (`GET /filieres`, `GET /cohortes`).
 */
export function usePublicFilieres() {
  const [filieres, setFilieres] = useState([]);
  const [domaines, setDomaines] = useState([]);
  const [cohortes, setCohortes] = useState([]);
  const [tracks, setTracks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const load = useCallback(async () => {
    setError(false);
    setLoading(true);
    try {
      const [rows, domainesRows, cohortesRows] = await Promise.all([
        fetchFilieres(),
        fetchDomaines(),
        fetchCohortes(),
      ]);
      const list = Array.isArray(rows) ? rows : [];
      const domainesList = Array.isArray(domainesRows) ? domainesRows : [];
      const cohortesList = Array.isArray(cohortesRows) ? cohortesRows : [];
      setFilieres(list);
      setDomaines(domainesList);
      setCohortes(cohortesList);
      setTracks(groupFilieresForPublicVitrine(list, domainesList));
    } catch {
      setError(true);
      setFilieres([]);
      setDomaines([]);
      setCohortes([]);
      setTracks([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  return { filieres, domaines, cohortes, tracks, loading, error, reload: load };
}
